'use strict';

module.exports = function () {
    var dictionary = function (word) {
        switch (word) {
            case 'zone':
                return 'Zone';
            case 'local_user':
                return 'Local User';
            case 'local_ip':
                return 'Local IP';
            case 'remote_user':
                return 'Remote User';
            case 'remote_ip':
                return 'Remote IP';
            case 'type':
                return 'Type';
            default:
                return word;
        }
    };
    return dictionary;
}


/** WEBPACK FOOTER **
 ** ./src/pages/services/dictionary.js
 **/